import { render, staticRenderFns } from "./ldEditPsg.vue?vue&type=template&id=23b15663&scoped=true"
import script from "./ldEditPsg.vue?vue&type=script&lang=js"
export * from "./ldEditPsg.vue?vue&type=script&lang=js"
import style0 from "./ldEditPsg.vue?vue&type=style&index=0&id=23b15663&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b15663",
  null
  
)

export default component.exports